import ActionTypes from '../constants/ActionTypes'; 

const initialState = {
    loading: false,
    gaugedata: {},
    error: null,
};

const cameraReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.CAMERA_EDIT_REQUEST:
            return { ...state, loading: true };
        case ActionTypes.CAMERA_EDIT_SUCCESS:
            return { ...state, loading: false, gaugedata: action.payload};
        case ActionTypes.CAMERA_EDIT_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case ActionTypes.CAMERA_EDIT_SUBMIT_REQUEST:
            return { ...state, loading: true };
        case ActionTypes.CAMERA_EDIT_SUBMIT_SUCCESS:
            return { ...state, loading: false, message: action.payload };
        case ActionTypes.CAMERA_EDIT_SUBMIT_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default cameraReducer;
